import store from "@/store";
import request from "@/utils/request";

export async function getTextbookList(params) {
    params.contTypeCd = '201002' // 교재
    params.postTypeCd = '202001' // 원글
    console.log("@@ get textbook list : getCsContList");
    let result = request.get("/api/cs/csCont/",{params});
    return result;
}

export async function getCsContList(params) {
    console.log("@@ get list : getCsContList");
    let result = request.get("/api/cs/csCont/",{params});
    return result;
}

export async function getCsContTreeList(params) {
    console.log("@@ get list : getCsContTreeList");
    let result = request.get("/api/cs/csCont/tree/list",{params});
    return result;
}


export async function getCsContItem(params) {
    console.log("@@ get item : getCsContItem");
    let result = request.get(`/api/cs/csCont/${params.contSeq}`,{params} );
    return result;
}

export async function saveCsCont(params) {
    console.log("@@ post save : saveCsCont");
    let result = request.post(`/api/cs/csCont/`,params);
    return result;
}

export async function saveCsContList(params) {
    console.log("@@ post save : saveCsContList");
    let result = request.post(`/api/cs/csCont/list/`,params);
    return result;
}

export async function saveCsContExcel(params) {
    console.log("@@ post save : saveCsContExcel");
    let result = request.post(`/api/cs/csCont/excelUpload/unit/`,params);
    return result;
}

export async function deleteCsCont(params) {
    console.log("@@ delete : deleteCsCont");
    let result = request.delete(`/api/cs/csCont/`,{params});
    return result;
}
export async function deleteCsContByOrgContSeq(params) {
    console.log("@@ delete : deleteCsContByOrgContSeq");
    let result = request.delete(`/api/cs/csCont/orgContSeq/${params.contSeq}`,{params});
    return result;
}